export default __webpack_public_path__ + "static/media/antonio-quaglietta.ffab77ab.png";